export default __webpack_public_path__ + "static/media/appVersion.b33bf693.svg";